import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { KYMW4400Model } from '../kymw4400.model';
import { Injectable } from '@angular/core';
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';

// レスポンス構造
export type GetAutoKomaArrangePatternListResponse = {
  CodeDiv: string;
  CodeValue: string;
  CodeName: string;
  CodeDivName: string;
  Reserve1: string;
  Reserve2: string;
  ReserveNum1: number;
  ReserveNum2: number;
  SortNum: number;
  StartOrderCode: string;
  EndOrderCode: string;
}[];

/**
 * 自動コマ割パターン取得サービス
 * @export GetAutoKomaArrangePatternListService
 * @class GetAutoKomaArrangePatternListService
 * @extends {PlessJsonResponderSub}
 */
@Injectable()
export class GetAutoKomaArrangePatternListService extends PlessJsonResponderSub<GetAutoKomaArrangePatternListResponse> {
  model: KYMW4400Model;
  codeDiv: string;
  private succeed: () => void;
  private fail: () => void;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof GetAutoKomaArrangePatternListService
   */
  private getBody(): PlessRequest {
    return new PlessRequest({
      parameter: {
        OrderCode: this.model.orderCode,
        CodeDiv: this.codeDiv,
      }
    });
  }

  /**
   * API呼び出し
   *
   * @param model
   * @memberof GetAutoKomaArrangePatternListService
   */
  execute(
    model: KYMW4400Model,
    codeDiv: string,
    s: () => void = null,
    f: () => void = null
  ): void {
    this.model = model;
    this.codeDiv = codeDiv;
    this.succeed = s;
    this.fail = f;
    this.send('getAutoKomaArrangePatternList', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof GetAutoKomaArrangePatternListService
   */
  success(data: GetAutoKomaArrangePatternListResponse) {
    this.model.autoArrangePatternSelectItems = data;
    if (this.succeed) this.succeed();
  }

  /**
   * async/await 記述用
   *
   * @param model
   * @returns Promise<void>
   */
  public executeAsync(model: KYMW4400Model, codeDiv: string): Promise<void> {
    return new Promise((resolve, reject) => {
      this.execute(
        model,
        codeDiv,
        () => resolve(),
        () => reject()
      );
    });
  }

  protected statusError(status: string, result: any) {
    super.statusError(status, result);
    if (this.fail) this.fail();
  }
}
